import request from '@/utils/request';

export default {
  async fetch({ commit }, params = {}) {
    const { data } = await request.get('/referrals', { params });
    const referrals = data.referrals || data;
    const items = Array.isArray(referrals) ? referrals : referrals.data || [];
    const pagination = {
      page: referrals.current_page || 1,
      pages: referrals.last_page || 1,
      size: referrals.per_page || 50,
      count: referrals.total || 0,
      indexStartsFrom: referrals.from || 1,
    };
    commit('setData', { items, pagination, filters: params.filters || {} });
    return data;
  },
};
